//This is the dinner foods page

import DinnerFoodsComponent from "../../../NonMVPComponents/Recipes/Dinner/DinnerFoodsComponent";

const DinnerFoods = () => {
  return (
    <div>
      <DinnerFoodsComponent />
    </div>
  );
};

export default DinnerFoods;
